import { render, staticRenderFns } from "./ModalMenuItemGallery.vue?vue&type=template&id=1dbf28b8&"
import script from "./ModalMenuItemGallery.vue?vue&type=script&lang=js&"
export * from "./ModalMenuItemGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports